module.exports = __webpack_public_path__ + "static/media/(V)_MG_5146_-_Pro-Natura_-_Moda_Feminina_-_Moda_Feminina_Infantil.d3541e11.jpg";